const listPage = require('./listPage')
const editPage = require('./editPage')

module.exports = {
  title: '批量銷貨單',
  list: listPage,
  edit: editPage,
}
